export default [
    //快递包裹
    {   //列表
        path: "expresspackage/list",
        name: "expressPackage",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/index"),
    },

    {   //查看
        path: "expresspackage/update",
        name: "expressPackageDetail",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/update"),
    },

    //订单包裹异动
    {   //列表
        path: "expresspackage/delivertrecall/list",
        name: "delivertRecall",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/delivertrecall/index"),
    },

    {   //查看
        path: "expresspackage/delivertrecall/update/:type",
        name: "delivertRecallUpdate",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/delivertrecall/update"),
    },

    //订单包裹异动管理端
    {   //列表
        path: "expresspackage/delivertrecalladmin/list",
        name: "delivertRecallAdmin",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/delivertrecalladmin/index"),
    },

    {   //查看
        path: "expresspackage/delivertrecalladmin/update/:type",
        name: "delivertRecallAdminUpdate",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/expresspackage/delivertrecalladmin/update"),
    },
]


